import React from 'react';
import { motion } from 'framer-motion';
import { Compass, Hand } from 'lucide-react';

const HintSection: React.FC = () => {
  return (
    <section className="py-24 bg-dark text-white">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center max-w-6xl mx-auto">
          <div className="md:w-1/2 mb-12 md:mb-0 md:pr-12">
            <div className="relative w-full aspect-square max-w-md mx-auto">
              <div className="absolute inset-0 rounded-full bg-gradient-to-br from-primary/20 to-dark blur-3xl"></div>
              
              <div className="relative h-full flex items-center justify-center">
                <div className="w-3/4 h-3/4 border-2 border-primary/30 rounded-full flex items-center justify-center">
                  <div className="w-2/3 h-2/3 border-2 border-primary/50 rounded-full flex items-center justify-center">
                    <div className="w-1/2 h-1/2 border-2 border-primary/70 rounded-full flex items-center justify-center">
                      <Hand className="w-10 h-10 text-primary" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="md:w-1/2 text-center md:text-left">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="inline-flex items-center mb-6 bg-white/5 backdrop-blur-sm px-4 py-2 rounded-full border border-white/10"
            >
              <Compass className="w-5 h-5 mr-2 text-primary" />
              <span className="text-sm font-medium tracking-wide text-white/80">The Path Forward</span>
            </motion.div>
            
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="font-serif text-3xl md:text-4xl font-semibold mb-8 leading-tight"
            >
              The solution exists <span className="text-primary">outside your screen</span>
            </motion.h2>
            
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 }}
              className="text-white/70 text-lg mb-6"
            >
              From distraction to direction. Imagination becomes reality when we reclaim our attention. The ability to focus is the key to unlocking our potential.
            </motion.p>
            
            <motion.ul
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.6 }}
              className="mt-8 space-y-4"
            >
              {[
                'Effortless transitions between digital and physical',
                'Reclaim hours of lost time daily',
                'Designed for the human experience'
              ].map((item, index) => (
                <li key={index} className="flex items-center">
                  <div className="w-2 h-2 rounded-full bg-primary mr-3"></div>
                  <span className="text-white/80">{item}</span>
                </li>
              ))}
            </motion.ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HintSection;